<template>
    <inertia-link
        v-if="withdrawalPlayerWithPinAllowed"
        :href="route('withdraw.index')"
        class="flex items-center px-2 md:px-4 py-1 font-medium ml-2 hover:text-purple-700 focus:text-purple-700 text-sm md:text-md"
        title="Balance">
        <font-awesome-icon class="mr-2" icon="wallet"/>
        <span><span class="hidden md:inline">{{ $t('Balance') }}: </span>{{ newBalance | currency }}</span>
    </inertia-link>
    <div
        v-else
        class="flex items-center px-2 md:px-4 py-1 font-medium ml-2 text-sm md:text-md"
        title="Balance">
        <font-awesome-icon class="mr-2" icon="wallet"/>
        <span><span class="hidden md:inline">{{ $t('Balance') }}: </span>{{ newBalance | currency }}</span>
    </div>
</template>

<script>
export default {
    name: 'Balance',
    props: ['balance'],
    data() {
        return {
            newBalance: 0,
            withdrawalPlayerWithPinAllowed: window.withdrawal_player_with_pin,
        }
    },
    created() {
        this.newBalance = this.balance;

        Echo
            .private(`player-${this.$page.props.user.id}`)
            .listen('BalanceChanged', (e) => {
                this.newBalance = e.balance;
            })
            .listen('PlayerDeactivated', (e) => {
                axios.post(route('logout').url()).then(() => {
                    window.location = '/';
                });
            })
        ;
    },
    beforeDestroy () {
        clearInterval(this.polling);
    }
}
</script>

<style lang="sass" scoped>

</style>
